import { isClientSide } from "@helper/utils";
import { useEffect, useState } from "react";

type UseHeaderScrollReturn = {
  showMosqueBtn: boolean;
  isDesktopScrolled: boolean;
};

export function useHeaderScroll(
  compactMobileHeader?: boolean,
): UseHeaderScrollReturn {
  const [showMosqueBtn, setShowMosqueBtn] = useState(false);
  const [isDesktopScrolled, setIsDesktopScrolled] = useState(false);

  useEffect(() => {
    if (!isClientSide) return;

    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Mobile
      setShowMosqueBtn(compactMobileHeader || scrollY > 100);

      // Desktop with hysteresis
      setIsDesktopScrolled((prev) => {
        if (!prev && scrollY > 300) return true; // enter
        if (prev && scrollY < 200) return false; // exit
        return prev;
      });
    };

    handleScroll(); // Check initial position
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [compactMobileHeader]);

  return {
    showMosqueBtn,
    isDesktopScrolled,
  };
}
